import { useRouter } from 'next/router'

import { openChatBot } from '~/utils/chatBot'
import { DailyOrFestivalReservation, EventReservation, isVoucher, useCheckoutContext } from '~/utils/checkoutFlow'
import { isDaily, isEvent, isFER } from '~/utils/isReservableType'

import { paths } from '~/constants'
import { VoucherDataQuery } from '~/generated/graphql'
import { gt } from '~/locale'
import Button from '~/shared/atoms/Button'

import {
  ReservationExpiredActions,
  ReservationExpiredContent,
  ReservationExpiredTitle,
  ReservationExpiredWrapper,
} from './ReservationExpiredShards'

function hasReservable(
  reservation: DailyOrFestivalReservation | EventReservation | NonNullable<VoucherDataQuery['voucher']>
): reservation is DailyOrFestivalReservation | EventReservation {
  return (reservation as DailyOrFestivalReservation | EventReservation).reservable !== undefined
}

export default function ReservationExpired() {
  const { tp } = gt

  const router = useRouter()

  const { reservation, editMode } = useCheckoutContext()

  const handleClose = () => {
    if (editMode) return router.push(paths.reservations)

    if (isVoucher(reservation)) return router.push(paths.giftEventsListing)

    const reservable = hasReservable(reservation) && reservation.reservable

    if (reservable) {
      if (isFER(reservable)) return router.push(paths.festivalListing(reservable.festivalEdition.festival.slug, reservable.id))
      if (isDaily(reservable)) return router.push(paths.singleRestaurant(reservable.restaurant))
      if (isEvent(reservable)) return router.push(paths.sideEventsListing)
    }
  }

  return (
    <ReservationExpiredWrapper>
      <ReservationExpiredTitle>{tp('ReservationExpired', 'Reservation expired')}</ReservationExpiredTitle>
      <ReservationExpiredContent>
        {gt.tp('ReservationExpired', 'It looks like your reservation has expired.')}
        {'\n'}
        {gt.tp('ReservationExpired', 'If you need assistance,')} <span>{gt.tp('ReservationExpired', 'use our chat support.')}</span>
      </ReservationExpiredContent>
      <ReservationExpiredActions>
        <Button
          color='orange'
          variant='outlined'
          label={tp('ReservationExpired', 'Open chat')}
          width='full'
          onClick={() => openChatBot()}
        />
        <Button color='orange' label={tp('ReservationExpired', 'Close')} width='full' onClick={handleClose} />
      </ReservationExpiredActions>
    </ReservationExpiredWrapper>
  )
}
